var $4e47f19ffc9065c1$exports = {};
$4e47f19ffc9065c1$exports = {
    "colorSwatchPicker": `kleurstalen`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Selecteer een item`,
    "tableResizer": `Resizer`
};


export {$4e47f19ffc9065c1$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
